<template>
  <div class="calendar">
    <div class="month">{{ month }}</div>
    <div class="day">{{ day }}</div>
  </div>
</template>

<script>
export default {
  name: 'Calendar',
  props: [ 'date' ],
  data: function () {
    return {};
  },
  computed: {
    month: function () {
      let date = new Date(this.date);
      return date.toLocaleString('en-US', { month: 'short' });
    },
    day: function () {
      let date = new Date(this.date);
      return date.toLocaleString('en-US', { day: 'numeric' });
    },
  }
}
</script>

<style lang="scss" scoped>
div.calendar {
  background: #FFFFFF;
  border: 1px solid #ECECEC;
  box-shadow: 0 10px 30px 0 rgba(0,0,0,0.07);
  border-radius: 4px;
  overflow: hidden;
  max-width: 90px;

  div.month {
    background-color: var(--accentColor);
    color: white;
    font-size: 0.75rem;
    font-weight: 500;
    text-align: center;
    letter-spacing: 2.1px;
    text-transform: uppercase;
    padding: 4px 0;
    transition: background-color 250ms;
  }

  div.day {
    font-size: 1.875rem;
    letter-spacing: 5.25px;
    color: #222222;
    text-align: center;
    padding: 16px 0;
    line-height: 1;
    padding-left: 5.25px;
  }
}
</style>
